import AddChallenge from "./components/AddChallenge";
import {  profile } from "../../slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const Admin = () => {

  const dispatch = useDispatch();
  const {user} = useSelector((state) => state.user);


  useEffect(() =>{
    const fetchProfile = async () => {
      await dispatch(profile());
    }
    
    fetchProfile();
  }, [user]);

  return (
    <>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="min-h-dvh flex min-h-dvh relative z-10 px-6 pt-10 pb-8 sm:mx-auto justify-center mt-7">
        <AddChallenge />
      </div>
    </>
  )
}

export default Admin